import type { FilterConditionDto } from './condition';
import { BdCondition } from './condition';

export const BD_TRUE_CONDITION_ID = 'true';

export class BdTrueCondition extends BdCondition {
  constructor() {
    super(BD_TRUE_CONDITION_ID);
  }

  toJSON(): FilterConditionDto {
    return {
      [BD_TRUE_CONDITION_ID]: {},
    };
  }
}
